import Vue from 'vue'
import Vuetify from 'vuetify/lib/framework'
// import zhHans from 'vuetify/lib/locale/zh-Hans'
import './default-preset/preset/overrides.scss'

Vuetify.config.silent = false // 此选项将停止 所有的 Vuetify 日志和警告

Vue.use(Vuetify)

export default new Vuetify({
  // preset,
  icons: {
    iconfont: 'mdiSvg',
  },
  // lang: {
  //   locales: { zhHans },
  //   current: 'zhHans',
  // },
  theme: {
    options: {
      customProperties: true, // 启用 customProperties 也会为每个主题颜色生成一个 css变量
      variations: false,
    },
    themes: {
      light: {
        // primary: '#9155FD',
        primary: '#0078D6',
        accent: '#0d6efd',
        // secondary: '#8A8D93',
        secondary: '#4EAFFD',

        success: '#56CA00',
        info: '#16B1FF',
        warning: '#FFB400',
        // error: '#FF4C51',
        error: '#D92121',
      },
      dark: {
        primary: '#9155FD',
        accent: '#0d6efd',
        secondary: '#8A8D93',
        success: '#56CA00',
        info: '#16B1FF',
        warning: '#FFB400',
        error: '#FF4C51',
      },
    },
  },
})
